window.ES_COMPONENTS = window.ES_COMPONENTS || {}; window.ES_TEMPLATES = window.ES_TEMPLATES || {};
ES_TEMPLATES["legal-d"] = "\n\n  <section style=\"background: #EBEAE6\">\n    <div style=\"max-width: 900px; margin: 0 auto; padding: 64px 32px 48px; display: flex; flex-direction: column; gap: 18px\">\n      <div role=\"tablist\" style=\"align-self: flex-start; display: inline-flex; gap: 4px; padding: 4px; border: 1px solid #D6D6D6; border-radius: 999px; background: #FFFFFF\"><sc-for list=\"{{tabs}}\" as=\"tb\" hint-placeholder-count=\"2\"><button onClick=\"{{tb.pick}}\" style=\"height: 40px; padding: 0 18px; border-radius: 999px; border: 0; background: {{tb.bg}}; color: {{tb.fg}}; font-family: inherit; font-weight: 700; font-size: 14px; cursor: pointer\">{{tb.t}}</button></sc-for></div>\n      <span style=\"font-size: 12px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: #6E6E6E\">Legal · mis à jour le {{updated}}</span>\n      <h1 style=\"margin: 0; font-weight: 900; font-size: 64px; line-height: .95; letter-spacing: -0.04em; text-transform: uppercase\">{{doc.title}}</h1>\n      <p style=\"margin: 0; font-size: 19px; line-height: 1.55; color: #3D3D3D\">{{doc.intro}}</p>\n    </div>\n  </section>\n  <section>\n    <div style=\"max-width: 900px; margin: 0 auto; padding: 56px 32px 96px; display: flex; flex-direction: column; gap: 18px\">\n      <sc-if value=\"{{hasTldr}}\"><div style=\"border: 2px solid #111111; border-radius: 14px; padding: 24px 22px 20px; position: relative; margin-bottom: 8px\"><span style=\"position: absolute; top: -13px; left: 20px; background: {{accent}}; font-size: 12px; font-weight: 900; letter-spacing: 0.12em; text-transform: uppercase; padding: 5px 10px; border-radius: 4px\">In short</span><ul style=\"margin: 4px 0 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 10px\"><sc-for list=\"{{doc.tldr}}\" as=\"t\" hint-placeholder-count=\"4\"><li style=\"display: flex; gap: 12px; font-size: 16px; line-height: 1.5\"><svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#111111\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"flex: 0 0 auto; margin-top: 2px\"><path d=\"M5 12l5 5L20 7\"></path></svg><span>{{t}}</span></li></sc-for></ul></div></sc-if>\n      \n        <sc-for list=\"{{blocks}}\" as=\"b\" hint-placeholder-count=\"8\">\n          <sc-if value=\"{{b.isH2}}\"><h2 style=\"margin: 24px 0 0; font-weight: 900; font-size: 26px; line-height: 1.1; letter-spacing: -0.02em\">{{b.t}}</h2></sc-if>\n          <sc-if value=\"{{b.isP}}\"><p style=\"margin: 0; font-size: 17px; line-height: 1.7; color: #2B2B2B\">{{b.t}}</p></sc-if>\n          <sc-if value=\"{{b.isUl}}\"><ul style=\"margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 8px\"><sc-for list=\"{{b.items}}\" as=\"it\" hint-placeholder-count=\"3\"><li style=\"display: flex; gap: 12px; font-size: 17px; line-height: 1.6; color: #2B2B2B\"><span style=\"flex: 0 0 auto; width: 7px; height: 7px; border-radius: 50%; background: {{accent}}; margin-top: 10px\"></span><span>{{it}}</span></li></sc-for></ul></sc-if>\n          <sc-if value=\"{{b.isDl}}\"><div style=\"border-top: 2px solid #111111\"><sc-for list=\"{{b.rows}}\" as=\"r\" hint-placeholder-count=\"6\"><div style=\"display: grid; grid-template-columns: 220px 1fr; gap: 4px 20px; padding: 12px 0; border-bottom: 1px solid #E4E4E4; font-size: 17px; line-height: 1.5\"><span style=\"font-weight: 700; color: #6E6E6E\">{{r.a}}</span><span>{{r.b}}</span></div></sc-for></div></sc-if>\n          <sc-if value=\"{{b.isTable}}\"><div style=\"overflow-x: auto; border: 1px solid #E4E4E4; border-radius: 10px\"><table style=\"width: 100%; border-collapse: collapse; font-size: 15px; line-height: 1.45\"><thead><tr><sc-for list=\"{{b.head}}\" as=\"hd\" hint-placeholder-count=\"3\"><th style=\"text-align: left; padding: 12px 16px; background: #111111; color: #FFFFFF; font-weight: 900; font-size: 11px; letter-spacing: 0.08em; text-transform: uppercase\">{{hd}}</th></sc-for></tr></thead><tbody><sc-for list=\"{{b.rows}}\" as=\"r\" hint-placeholder-count=\"3\"><tr style=\"border-top: 1px solid #E4E4E4\"><sc-for list=\"{{r.cells}}\" as=\"cl\" hint-placeholder-count=\"3\"><td style=\"padding: 12px 16px; font-weight: {{cl.w}}; vertical-align: top\">{{cl.c}}</td></sc-for></tr></sc-for></tbody></table></div></sc-if>\n        </sc-for>\n    </div>\n  </section>\n\n";
ES_COMPONENTS["legal-d"] = function(DCLogic){

const DOCS = [
{
"id": "mentions",
"tab": "Mentions légales",
"title": "Mentions légales",
"intro": "Qui se cache derrière ce site, et les règles qui s'appliquent au site. On a fait court et clair.",
"tldr": [],
"blocks": [
{
"k": "h2",
"t": "Éditeur du site"
},
{
"k": "dl",
"rows": [
{
"a": "Société",
"b": "NUTRALABS SAS"
},
{
"a": "Forme",
"b": "Société par actions simplifiée à associé unique"
},
{
"a": "Capital social",
"b": "100 000 MAD"
},
{
"a": "Siège social",
"b": "131, boulevard d'Anfa, Résidence Azur, bureau 11B, Casablanca, Maroc"
},
{
"a": "Registre du commerce",
"b": "535119 (Tribunal de commerce de Casablanca)"
},
{
"a": "ICE",
"b": "003027147000007"
}
]
},
{
"k": "h2",
"t": "Directeur de la publication"
},
{
"k": "p",
"t": "DG NUTRALABS"
},
{
"k": "h2",
"t": "Hébergement"
},
{
"k": "p",
"t": "Le site est hébergé par Shopify Inc., 151 O'Connor Street, Ground floor, Ottawa (Ontario) K2P 2L8, Canada - www.shopify.com."
},
{
"k": "h2",
"t": "Marque et propriété intellectuelle"
},
{
"k": "p",
"t": "EVERSTRONG® et EVERSTRONG NUTRITION® sont des marques d'EVERSTRONG USA LLC. Les produits EVERSTRONG® sont fabriqués sous licence exclusive pour EVERSTRONG USA LLC et distribués au Maroc par NUTRALABS SAS."
},
{
"k": "p",
"t": "Les textes, logos, visuels, illustrations et la structure du site sont protégés par le droit de la propriété industrielle (loi n° 17-97) et le droit d'auteur (loi n° 2-00). Toute reproduction ou utilisation, totale ou partielle, sans autorisation écrite préalable est interdite."
},
{
"k": "h2",
"t": "Nos produits"
},
{
"k": "p",
"t": "Les produits présentés sont des compléments alimentaires. Ils ne remplacent pas une alimentation variée et équilibrée ni un mode de vie sain. Ils sont déconseillés aux enfants et aux femmes enceintes ou allaitantes. Respectez la dose journalière recommandée indiquée sur l'étiquette."
},
{
"k": "p",
"t": "Les numéros d'enregistrement de nos produits auprès des autorités sanitaires marocaines sont consultables sur la page « Nos enregistrements »."
},
{
"k": "h2",
"t": "Contenus d'information"
},
{
"k": "p",
"t": "Les articles du blog sont fournis à titre d'information générale. Ils sont rédigés à partir de sources publiées et ne remplacent pas l'avis d'un médecin, d'un pharmacien ou d'un diététicien. En cas de doute, de traitement ou de problème de santé, demandez conseil à un professionnel."
},
{
"k": "h2",
"t": "Responsabilité"
},
{
"k": "p",
"t": "Nous faisons notre maximum pour que les informations du site soient exactes et à jour, sans pouvoir garantir l'absence totale d'erreur. Le site peut contenir des liens vers des sites tiers : nous ne contrôlons pas leur contenu et n'en sommes pas responsables."
},
{
"k": "h2",
"t": "Droit applicable"
},
{
"k": "p",
"t": "Le site et ces mentions sont soumis au droit marocain. En cas de litige, et à défaut d'accord amiable, les tribunaux compétents de Casablanca seront saisis, sous réserve des règles protectrices du consommateur prévues par la loi n° 31-08."
}
]
},
{
"id": "confidentialite",
"tab": "Confidentialité",
"title": "Politique de confidentialité",
"intro": "Tes données t'appartiennent. Voici, simplement, ce que nous collectons, pourquoi, et comment garder la main dessus.",
"tldr": [
"Nous collectons le minimum : ton e-mail si tu t'inscris.",
"Nous ne vendons jamais tes données.",
"Tu peux te désinscrire en un clic et demander la suppression de tes données à tout moment."
],
"blocks": [
{
"k": "h2",
"t": "1. Qui est responsable de tes données ?"
},
{
"k": "p",
"t": "NUTRALABS SAS, 131, boulevard d'Anfa, Résidence Azur, bureau 11B, Casablanca, Maroc, RC 535119 (Tribunal de commerce de Casablanca), est responsable du traitement des données collectées sur ce site."
},
{
"k": "h2",
"t": "2. Quelles données et pourquoi ?"
},
{
"k": "table",
"head": [
"Situation",
"Données",
"Pourquoi"
],
"rows": [
[
"Inscription « Join the Team »",
"Adresse e-mail",
"T'informer du lancement de la boutique en ligne, de nos offres et de nos nouveautés"
],
[
"Navigation sur le site",
"Données techniques et cookies (pages vues, appareil, navigateur)",
"Faire fonctionner le site, mesurer l'audience, l'améliorer"
]
]
},
{
"k": "p",
"t": "Nous ne collectons aucune donnée de santé et ne te demandons pas d'informations sensibles."
},
{
"k": "h2",
"t": "3. Sur quelle base ?"
},
{
"k": "p",
"t": "L'envoi d'e-mails repose sur ton consentement, donné en t'inscrivant. Tu peux le retirer à tout moment grâce au lien de désinscription présent dans chaque e-mail. Les cookies non essentiels ne sont déposés qu'avec ton accord."
},
{
"k": "h2",
"t": "4. Qui y a accès ?"
},
{
"k": "p",
"t": "Seules les personnes habilitées de NUTRALABS SAS ont accès à tes données, ainsi que notre prestataire technique, uniquement pour les besoins du service :"
},
{
"k": "ul",
"items": [
"Shopify (hébergement du site et des données)."
]
},
{
"k": "p",
"t": "Nous ne vendons, ne louons et ne cédons jamais tes données à des tiers."
},
{
"k": "h2",
"t": "5. Transfert hors du Maroc"
},
{
"k": "p",
"t": "Nos prestataires techniques hébergent les données hors du Maroc, notamment au Canada, aux États-Unis ou dans l'Union européenne. Ces transferts sont encadrés conformément aux articles 43 et 44 de la loi n° 09-08."
},
{
"k": "h2",
"t": "6. Combien de temps ?"
},
{
"k": "table",
"head": [
"Données",
"Durée de conservation"
],
"rows": [
[
"E-mail « Join the Team »",
"Jusqu'à ta désinscription, ou 3 ans sans aucune interaction de ta part"
],
[
"Cookies de mesure d'audience",
"13 mois maximum"
]
]
},
{
"k": "h2",
"t": "7. Tes droits"
},
{
"k": "p",
"t": "Conformément à la loi n° 09-08, tu disposes d'un droit d'information, d'accès, de rectification et d'opposition, pour des motifs légitimes, au traitement de tes données. Tu peux aussi t'opposer à tout moment, sans frais, à l'envoi d'e-mails commerciaux."
},
{
"k": "p",
"t": "Une adresse de contact dédiée à l'exercice de ces droits sera communiquée prochainement sur cette page."
},
{
"k": "h2",
"t": "8. Cookies"
},
{
"k": "p",
"t": "Le site utilise des cookies nécessaires à son fonctionnement (sécurité, préférences) et, avec ton accord, des cookies de mesure d'audience. Tu peux accepter, refuser ou modifier tes choix à tout moment via le bandeau cookies ou les réglages de ton navigateur. Refuser les cookies non essentiels n'empêche pas d'utiliser le site."
},
{
"k": "h2",
"t": "9. Sécurité"
},
{
"k": "p",
"t": "Le site est accessible en HTTPS et nos prestataires appliquent des mesures de sécurité reconnues. Aucun système n'est infaillible : en cas d'incident touchant tes données, nous t'en informerons lorsque c'est requis."
},
{
"k": "h2",
"t": "10. Mineurs"
},
{
"k": "p",
"t": "Nos produits et notre newsletter s'adressent aux adultes. Nous ne collectons pas sciemment de données concernant des mineurs."
},
{
"k": "h2",
"t": "11. Mises à jour"
},
{
"k": "p",
"t": "Cette politique peut évoluer, notamment à l'ouverture de la boutique en ligne. La date de dernière mise à jour figure en haut de cette page."
}
]
}
];
const UPDATED = '9 octobre 2026';
const FOOTCOLS = [
  { t: 'Shop', links: ['Créatine'] },
  { t: 'Aide', links: ['Livraison & retours', 'Suivre ma commande', 'WhatsApp'] },
  { t: 'EVERSTRONG®', links: ['Our Story', 'Blog', 'Revendeurs'] }
];
const FOOTLINKS = ['Shop', 'Our Story', 'Blog', 'Aide & livraison', 'Contact'];

class Component extends DCLogic {
  constructor(props) {
    super(props);
    let d = 0;
    try { if ((window.ES_PROPS || {}).page === 'confidentialite') d = 1; } catch (e) {}
    this.state = { d };
  }
  renderVals() {
    const s = this.state || {};
    const di = s.d ?? 0;
    const D = DOCS[di];
    return {
      accent: this.props.accent ?? '#13BFD6',
      tabs: DOCS.map((x, i) => ({ t: x.tab, pick: () => { try { window.location.href = i === 0 ? '/pages/mentions-legales' : '/pages/confidentialite'; } catch (e) {} }, bg: i === di ? '#111111' : 'transparent', fg: i === di ? '#FFFFFF' : '#111111' })),
      doc: D, hasTldr: D.tldr.length > 0, updated: UPDATED,
      blocks: D.blocks.map(b => ({ ...b, isH2: b.k === 'h2', isP: b.k === 'p', isUl: b.k === 'ul', isDl: b.k === 'dl', isTable: b.k === 'table', items: b.items || [], head: b.head || [], rows: (b.rows || []).map(r => Array.isArray(r) ? ({ cells: r.map((c, j) => ({ c, w: j === 0 ? 700 : 400 })) }) : r) })),
      footCols: FOOTCOLS, footerLinks: FOOTLINKS
    };
  }
}

;return Component; };
